module.exports = __webpack_public_path__ + "img/logo_cts.6bfbf11e.jpg";